import * as React from "react";
import { CSSProperties } from "react";

import { Link } from "react-router-dom";

interface Props {
  manageText: string;
  isButtonVisible: boolean;
  navigateTo?: string;
  buttonText?: string;
  managerContainerStyle?: CSSProperties;
}

export const ManageWrapper: React.FC<Props> = ({
  buttonText,
  manageText,
  isButtonVisible,
  children,
  navigateTo,
  managerContainerStyle,
}) => {
  const Button = () =>
    isButtonVisible ? (
      <Link className="btn" to={navigateTo || "/"}>
        {buttonText}
      </Link>
    ) : null;

  return (
    <main className="main">
      <div className="wrap">
        <div className="intro">
          <h1 className="intro__title">
            Manage <span className="intro__title-highlight">{manageText}</span>
          </h1>
          <Button />
        </div>
        <div className="manager" style={managerContainerStyle}>
          {children}
        </div>
      </div>
    </main>
  );
};
